var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #c1d6ef;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #1e4ec6;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thank-you"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-1",
    d: "m82.19,0H18.81C8.44,0,0,8.44,0,18.81v52.18c0,10.37,8.44,18.81,18.81,18.81h19.26l10.34,10.34c.58.58,1.33.87,2.09.87s1.51-.29,2.09-.87l10.34-10.34h19.26c10.37,0,18.81-8.44,18.81-18.81V18.81c0-10.37-8.44-18.81-18.81-18.81h0Zm12.89,70.99c0,7.11-5.78,12.89-12.89,12.89h-20.49c-.78,0-1.54.31-2.09.87l-9.11,9.11-9.11-9.11c-.55-.56-1.31-.87-2.09-.87h-20.49c-7.11,0-12.89-5.78-12.89-12.89V18.81c0-7.11,5.78-12.89,12.89-12.89h63.39c7.11,0,12.89,5.78,12.89,12.89v52.18Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m18.08,45.85v4.08h-2.53v-11.35h4.27c2.31,0,3.89,1.52,3.89,3.63s-1.58,3.63-3.89,3.63h-1.74Zm1.49-2.18c.96,0,1.62-.56,1.62-1.44s-.66-1.46-1.62-1.46h-1.47v2.9h1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m25.28,49.94v-11.35h7.19v2.38h-4.66v2.16h4.23v2.22h-4.23v2.18h4.67v2.4h-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m41.79,49.94l-4.67-7.46v7.46h-2.51v-11.35h3.07l4.26,6.9v-6.9h2.53v11.35h-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.91,49.94v-11.35h4.11c3.41,0,5.7,2.18,5.7,5.68s-2.29,5.67-5.71,5.67h-4.1Zm4-2.38c1.74,0,3.17-1.01,3.17-3.28s-1.42-3.3-3.17-3.3h-1.47v6.58h1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m58.53,49.94v-11.35h2.56v11.35h-2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m70.72,49.94l-4.67-7.46v7.46h-2.51v-11.35h3.07l4.26,6.9v-6.9h2.53v11.35h-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m84.28,49.94l-.16-1.15c-.5.72-1.57,1.39-3.19,1.39-3.15,0-5.75-2.32-5.75-5.91s2.71-5.92,5.91-5.92,4.75,1.92,5.25,3.51l-2.43.85c-.18-.7-.93-1.98-2.82-1.98-1.54,0-3.34,1.02-3.34,3.55,0,2.37,1.57,3.6,3.41,3.6s2.66-1.22,2.8-1.86h-3.41v-2.14h5.78v6.07h-2.05Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.3f05edc2b0664df816fa1f16982f4f88.svg";
export { ForwardRef as ReactComponent };